var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCream2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14282 4.22222C5.14282 2.99492 6.16617 2 7.42853 2H16.5714C17.8338 2 18.8571 2.99492 18.8571 4.22222V6.44444C18.8571 7.05809 18.3455 7.55556 17.7143 7.55556H6.28567C5.65449 7.55556 5.14282 7.05809 5.14282 6.44444V4.22222Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.8013C4 10.236 4.47135 9.77778 5.05278 9.77778H18.9472C19.5287 9.77778 20 10.236 20 10.8013C20 13.8175 19.7437 16.8285 19.2337 19.8037L19.0407 20.9294C18.9348 21.5472 18.385 22 17.7407 22H6.25927C5.61504 22 5.06523 21.5472 4.95932 20.9294L4.76635 19.8037C4.25632 16.8285 4 13.8175 4 10.8013Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCream2);
export default __webpack_public_path__ + "static/media/cream-2.c1921c9617c8020d827043a9f4f6abd6.svg";
export { ForwardRef as ReactComponent };